import { render, staticRenderFns } from "./cloudSpace.vue?vue&type=template&id=d39540b6&scoped=true"
import script from "./cloudSpace.vue?vue&type=script&lang=js"
export * from "./cloudSpace.vue?vue&type=script&lang=js"
import style0 from "./cloudSpace.vue?vue&type=style&index=0&id=d39540b6&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d39540b6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/agent/workspace/c-webhlzfq_workbench-web_en_test/orca-ac-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d39540b6')) {
      api.createRecord('d39540b6', component.options)
    } else {
      api.reload('d39540b6', component.options)
    }
    module.hot.accept("./cloudSpace.vue?vue&type=template&id=d39540b6&scoped=true", function () {
      api.rerender('d39540b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cloudSpace/cloudSpace.vue"
export default component.exports